import type { IconType } from "@memorang/ui/icon";

const isScreenshotMode = false;

export const isMocked = false;

export const blackListedStudypackIdsForWeb: number[] = [];
export const defaultMasteryLabels = {
	low: "Needs work",
	medium: "Almost there",
	high: "Mastered",
	none: "Not answered",
};

const skillIconMap: Record<string, IconType> = {
	Writing: "file-document-edit-outline",
	写作: "file-document-edit-outline",
	ライティング: "file-document-edit-outline",
	Listening: "ear-hearing",
	听力: "ear-hearing",
	リスニング: "ear-hearing",
	Speaking: "microphone-outline",
	口语: "microphone-outline",
	スピーキング: "microphone-outline",
	Reading: "book-open-page-variant-outline",
	阅读: "book-open-page-variant-outline",
	読解: "book-open-page-variant-outline",
	リーディング: "book-open-page-variant-outline",
	"Reading & Listening": "book-open-page-variant-outline",
	"Speaking & Writing": "microphone-outline",
};
export const getBrightcoveVideoUrl = (videoId: number) =>
	`https://players.brightcove.net/2324982687001/PYxPM5GJJ_default/index.html?videoId=${videoId}`;

export { isScreenshotMode, skillIconMap };
